import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 21.168c3.532-1.543 6-5.067 6-9.168 0-5.523-4.477-10-10-10S4 6.477 4 12c0 4.1 2.468 7.625 6 9.168V23H8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-1.832ZM9.757 7.758c-.2.2-.216.52-.037.74l2.373 2.9a2 2 0 0 0 2.12 2.59l1.205 1.473a.5.5 0 0 0 .74.037l1.34-1.34a.5.5 0 0 0-.037-.74l-1.472-1.205a2 2 0 0 0-2.591-2.12l-2.9-2.373a.553.553 0 0 0-.74.037Z"
    />
  </svg>
);
export default IconPressureFilledSizeL;
